import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TypeArticle } from 'src/api/models/type-article';

@Component({
  selector: 'app-article-type',
  templateUrl: './article-type.component.html',
  styleUrls: ['./article-type.component.css']
})
export class ArticleTypeComponent implements OnInit {

  @Input('id') public id: number;

  constructor(private translateService: TranslateService) { }

  ngOnInit(): void {
  }

  GetArticleType(t: TypeArticle) {
    if (t === undefined) {
      return '';
    } else {
      return this.translateService.instant('Stock.Articles.Types.' + TypeArticle[t]);
    }
  } 
}
